@if (docUrl != '') {
  <div class="row"  style="height:80vh;">
    <iframe [src]="docUrl" style="width:100%;"></iframe>
  </div>
}